import React from 'react';
import ModuleBase from '@/components/general/ModuleBase';
import { ImageModel, ModuleBaseModel, ModuleBasePropsModel } from '@/types';
import classNames from 'classnames';

interface ImageSingleProps extends ModuleBasePropsModel {
  image: ImageModel;
  alignment?: 'Left' | 'Center' | 'Right';
}

interface ImageSingleData extends ModuleBaseModel<ImageSingleProps> {}

const ImageSingle: React.FC<ImageSingleData> = (data) => {
  const { props } = data;
  
  if (!props?.image?.imageUrl) return null;

  const isSvg = props.image.imageUrl.toLowerCase().endsWith('.svg');

  const alignmentClass = classNames({
    'text-left': props.alignment === 'Left',
    'text-center': props.alignment === 'Center',
    'text-right': props.alignment === 'Right',
  });

  return (
    <ModuleBase data={data}>
      <div className="container mx-auto py-0">
        <div className={classNames('mx-auto w-full md:w-9/12', alignmentClass)}>
          {isSvg ? (
            <object type="image/svg+xml" data={props.image.imageUrl} />
          ) : (
            <img src={props.image.imageUrl} alt={props.image.imageAlt || ''} />
          )}
        </div>
      </div>
    </ModuleBase>
  );
};

export default ImageSingle;
